import React from "react";
import { BarLoader } from "react-spinners";
const LoadingStrip = () => {
  return (
    <div className="w-full overflow-hidden h-2 rounded-[4px] bg-[#F2F4F7]">
      <div className="h-full bg-[#FF6600] rounded-[4px] animate-loading"></div>
    </div>
  );
};

export default LoadingStrip;
